import coreStore from "./core-store";

const remoteResource = 'processing/api/v1/queries';

const store = coreStore.searchQueryStore(coreStore.createCoreStore('processQuery', remoteResource, 'processQueries'))

export default store;